import { render, staticRenderFns } from "./ModalShowEmployees.vue?vue&type=template&id=80b7258c&scoped=true&lang=pug&"
import script from "./ModalShowEmployees.vue?vue&type=script&lang=js&"
export * from "./ModalShowEmployees.vue?vue&type=script&lang=js&"
import style0 from "./ModalShowEmployees.vue?vue&type=style&index=0&id=80b7258c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b7258c",
  null
  
)

export default component.exports